module.exports = __webpack_public_path__ + "img/folder-open.8f838ebf.png";